export class EmpleadoDatosPersonales {

    constructor({ tipoFrmEmpresa = null } = {}) {
        this.tipoFrmEmpresa = tipoFrmEmpresa;
        this.model = {
            id: { value: null, header: 'Código' },
            grupo: {
                value: [],
                header: 'Empresas:',
                required: 'Seleccione por lo menos una'
            },
            tipo_empleado: {
                value: null, header: 'Tipo de empleado:', required: 'Tipo de empleado es requerido',
                table: false,
                tablePorTipo: {
                    FRM_TOYOTA: true,
                }
            },
            fecha: { value: new Date(), header: 'Fecha (día/mes/año):', required: 'Fecha es requerido' },
            pais: { value: null, header: 'País:', required: 'País es requerido' },
            provincia: { value: null, header: 'Provincia:', required: 'Provincia es requerido' },
            ciudad: { value: null, header: 'Ciudad:', required: 'Ciudad es requerida' },
            canton: { value: '', header: 'Ciudad', maxLength: 'Máximo 100 caracteres', minLength: 'Mínimo 4 caracteres', max: 100, min: 4, required: 'Ciudad es requerida' },
            tipo_informacion: { value: null, header: 'Tipo de declaración:', required: 'Tipo de declaración es requerido' },
            fecha_ingreso: {
                value: new Date(), header: 'Fecha de ingreso a la compañía:', required: 'Fecha es requerido',
                headerPorTipo: {
                    FRM_TOYOTA: 'FECHA DE INGRESO A LA COMPAÑÍA:',
                    FRM_DIFARE: 'FECHA DE INGRESO A LA COMPAÑÍA:',
                }
            },
            cargo: {
                value: '', header: 'Cargo que ocupa:', required: 'Cargo es requerido', maxLength: 'Máximo 200 caracteres',
                minLength: 'Mínimo 4 caracteres', max: 200, min: 4,
                headerPorTipo: {
                    FRM_TOYOTA: 'CARGO QUE OCUPA:',
                    FRM_DIFARE: 'CARGO QUE OCUPA:',
                }
            },
            tipo_identificacion: {
                value: null, header: 'Tipo de identificación:', required: 'Tipo de identificación es requerido',
                headerPorTipo: {
                    FRM_TOYOTA: 'Tipo de documento:',
                    FRM_DIFARE: 'Tipo de documento:',
                }
            },
            identificacion: {
                value: '', header: 'Identificación', required: 'Identificación es requerido', maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres', max: 50, min: 4,
                headerPorTipo: {
                    FRM_TOYOTA: 'No. doc. Identidad:',
                    FRM_DIFARE: 'No. doc. Identidad:',
                }
            },
            nombres: {
                value: '', header: 'Nombres completos', required: 'Nombres es requerido', maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres', max: 300, min: 4
            },
            apellidos: {
                value: '', header: 'Apellidos completos', required: 'Apellidos es requerido', maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres', max: 300, min: 4
            },
            nacionalidad: {
                value: null, header: 'Nacionalidad', required: 'Nacionalidad es requerido',
                headerPorTipo: {
                    FRM_TOYOTA: 'Nacionalidad:',
                    FRM_DIFARE: 'Nacionalidad:',
                }
            },
            genero: {
                value: null, header: 'Género', required: 'Género es requerido',
                headerPorTipo: {
                    FRM_TOYOTA: 'Género:',
                    FRM_DIFARE: 'Género:',
                }
            },
            fecha_nacimiento: { value: null, header: 'Fecha de nacimiento:', required: 'Fecha es requerido' },
            calles: {
                value: '', header: 'Calle Principal No. y Calle Secundaria:', required: 'Calles son requeridos', maxLength: 'Máximo 500 caracteres',
                minLength: 'Mínimo 4 caracteres', max: 500, min: 4
            },
            pais_personal: { value: null, header: 'País:', required: 'País es requerido' },
            provincia_personal: { value: null, header: 'Provincia:', required: 'Provincia es requerido' },
            ciudad_personal: { value: null, header: 'Ciudad:', required: 'Ciudad es requerida' },
            canton_personal: { value: '', header: 'Ciudad', maxLength: 'Máximo 100 caracteres', minLength: 'Mínimo 4 caracteres', max: 100, min: 4, required: 'Ciudad es requerida' },
            tiempo_residencia: {
                value: '', header: 'Tiempo que reside en el Ecuador (Si es extranjero):', maxLength: 'Máximo 100 caracteres', minLength: 'Mínimo 4 caracteres',
                max: 100, min: 4
            },
            correo_personal: { value: '', header: 'Correo electrónico personal:', maxLength: 'Máximo 100 caracteres', minLength: 'Mínimo 4 caracteres', max: 100, min: 4 },
            celular: {
                value: '', header: 'No. Celular:', required: 'No. Celular es requerido', maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres', max: 500, min: 4
            },
            telefono: {
                value: '', header: 'No. de teléfono del domicilio:', required: 'Teléfono es requerido', maxLength: 'Máximo 100 caracteres',
                minLength: 'Mínimo 4 caracteres', max: 500, min: 4
            },
            estado_civil: {
                value: null, header: 'Estado Civil', required: 'Estado Civil es requerido',
                headerPorTipo: {
                    FRM_TOYOTA: 'Estado civil:',
                    FRM_DIFARE: 'Estado civil:',
                }
            },
            separacion_bienes: {
                value: null, header: 'Separación de bienes:', required: 'Separación de bienes es requerido',
                table: false,
                tablePorTipo: {
                    FRM_TOYOTA: true,
                }
            },
        }
        Object.keys(this.model).forEach((key) => {
            const campo = this.model[key];
            if (campo.headerPorTipo && tipoFrmEmpresa && campo.headerPorTipo[tipoFrmEmpresa] !== undefined) {
                campo.header = campo.headerPorTipo[tipoFrmEmpresa];
            }
            if (campo.tablePorTipo && tipoFrmEmpresa && campo.tablePorTipo[tipoFrmEmpresa] !== undefined) {
                campo.table = campo.tablePorTipo[tipoFrmEmpresa];
            }
        });
    }

    optionLabel = 'nombre';
    pattern = { value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i, message: 'Correo no válido. E.g. example@email.com' };
}
